import React from 'react';
import { Button, Typography } from '@material-ui/core';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

type LiabilityPaginationProps = {
  page: number;
  setPage: (page: number) => void;
};

const LiabilityPagination: React.FC<LiabilityPaginationProps> = ({
  page,
  setPage
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '20px'
      }}
    >
      {/* Label on the left */}
      <Typography variant="body1">10-Week Interval</Typography>

      {/* Button Group styled like the image */}
      <div style={{ display: 'flex', gap: '10px' }}>
        <Button
          variant={page === -1 ? 'contained' : 'outlined'}
          color={page === -1 ? 'primary' : 'default'}
          onClick={() => setPage(-1)}
          style={{
            width: 'auto'
          }}
        >
          <NavigateBeforeIcon style={{ marginBottom: '2px' }} />
          Previous
        </Button>

        <Button
          variant={page === 0 ? 'contained' : 'outlined'}
          color={page === 0 ? 'primary' : 'default'}
          onClick={() => setPage(0)}
          style={{
            width: 'auto'
          }}
        >
          Current
        </Button>

        <Button
          variant={page === 1 ? 'contained' : 'outlined'}
          color={page === 1 ? 'primary' : 'default'}
          onClick={() => setPage(1)}
          style={{
            width: 'auto'
          }}
        >
          Next
          <NavigateNextIcon style={{ marginBottom: '2px' }} />
        </Button>
      </div>
    </div>
  );
};

export default LiabilityPagination;
